export var AppStorageKey;
(function (AppStorageKey) {
    //native
    AppStorageKey["sdcCertPac"] = "sdcCertPac";
    AppStorageKey["sdcCertAlias"] = "sdcCertAlias";
    AppStorageKey["sdcCert"] = "sdcCert";
    AppStorageKey["sdcCertKey"] = "sdcCertKey";
    AppStorageKey["sdcCertExpirationDate"] = "sdcCertExpirationDate";
    AppStorageKey["esdcCertExpirationDate"] = "esdcCertExpirationDate";
    AppStorageKey["sdcPin"] = "sdcPin";
    AppStorageKey["sdcTaxRates"] = "sdcTaxRates";
    AppStorageKey["syncData"] = "syncData";
    AppStorageKey["syncDataBackup"] = "syncDataBackup";
    AppStorageKey["printConfig"] = "printConfig";
    AppStorageKey["terminal"] = "terminal";
    AppStorageKey["cashRegister"] = "cashRegister";
    AppStorageKey["locale"] = "locale";
    AppStorageKey["orders"] = "orders";
    //local
    AppStorageKey["debtWarningSeenDate"] = "debtWarningSeenDate";
    AppStorageKey["scaleFilePath"] = "scaleFilePath";
    AppStorageKey["scaleScriptPath"] = "scaleScriptPath";
    AppStorageKey["priceTagsHeight"] = "priceTagsHeight";
    AppStorageKey["priceTagsPerRow"] = "priceTagsPerRow";
    AppStorageKey["kdsSettings"] = "kdsSettings";
    AppStorageKey["productTypesIndex"] = "productTypesIndex";
    AppStorageKey["productTypesOrder"] = "productTypesOrder";
    AppStorageKey["sdcUrl"] = "sdcUrl";
    AppStorageKey["sdcPreferred"] = "sdcPreferred";
    AppStorageKey["backoffice"] = "backoffice";
    AppStorageKey["offlineFrom"] = "offlineFrom";
    AppStorageKey["log"] = "log";
    AppStorageKey["lastOrderNumber"] = "lastOrderNumber";
    AppStorageKey["lastOrderInternalNumber"] = "lastOrderInternalNumber";
    AppStorageKey["lastOrderDate"] = "lastOrderDate";
    AppStorageKey["dataLoadedAt"] = "dataLoadedAt";
    AppStorageKey["tnToken"] = "tnToken";
    AppStorageKey["tnPKey"] = "tnPKey";
    AppStorageKey["userToken"] = "userToken";
    AppStorageKey["language"] = "language";
    AppStorageKey["currency"] = "currency";
    AppStorageKey["showProductSelect"] = "showProductSelect";
    AppStorageKey["lanServerAddress"] = "lanServerAddress";
    AppStorageKey["retailSplitterWidth"] = "retailSplitterWidth";
    AppStorageKey["hospitalitySplitRatio"] = "hospitalitySplitRatio";
    AppStorageKey["ordersHubTabViewedAt"] = "ordersHubTabViewedAt";
    AppStorageKey["forceA4FormatOverride"] = "forceA4FormatOverride";
    /** Last address a report PDF was emailed to from this device (venue-scoped). */
    AppStorageKey["reportPdfRecipient"] = "reportPdfRecipient";
})(AppStorageKey || (AppStorageKey = {}));
//# sourceMappingURL=defIAppStorage.js.map